import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12, default as _styled13, default as _styled14 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { getProductImageURL } from '@noths/polaris-client-utils';
import { Image as ImageComponent } from "../../../../foundations/Image/Image";
import * as testIds from "../constants/testIds";
import * as styles from "../styles/ProductCard.styles";
import { FavouriteButton, IconShipping, Price as PriceComponent } from "../../../../..";
export var ProductCard = function ProductCard(_ref) {
  var code = _ref.code,
    currency = _ref.currency,
    deliveryEventMessage = _ref.deliveryEventMessage,
    deliveryLabelText = _ref.deliveryLabelText,
    _ref$favourite = _ref.favourite,
    favourite = _ref$favourite === void 0 ? false : _ref$favourite,
    flushEdge = _ref.flushEdge,
    href = _ref.href,
    _ref$imageLoading = _ref.imageLoading,
    imageLoading = _ref$imageLoading === void 0 ? 'lazy' : _ref$imageLoading,
    imageSrc = _ref.imageSrc,
    onFavouriteClick = _ref.onFavouriteClick,
    onProductClick = _ref.onProductClick,
    _ref$onProductMouseDo = _ref.onProductMouseDown,
    onProductMouseDown = _ref$onProductMouseDo === void 0 ? function () {} : _ref$onProductMouseDo,
    _ref$onVisible = _ref.onVisible,
    onVisible = _ref$onVisible === void 0 ? function () {} : _ref$onVisible,
    partnerName = _ref.partnerName,
    preSalePrice = _ref.preSalePrice,
    price = _ref.price,
    primaryLabelText = _ref.primaryLabelText,
    _ref$primaryLabelType = _ref.primaryLabelType,
    primaryLabelType = _ref$primaryLabelType === void 0 ? 'new' : _ref$primaryLabelType,
    title = _ref.title;
  var rootElRef = useImpressionRef(function () {
    return onVisible({
      productCode: code
    });
  });
  return /*#__PURE__*/React.createElement(_StyledArticle, _extends({}, flushEdge ? {
    'data-flush-edge': flushEdge
  } : {}, {
    "data-testid": "product-card",
    ref: rootElRef,
    $_css: styles.outerCard
  }), /*#__PURE__*/React.createElement(_StyledA, {
    href: href,
    onClick: function onClick(evt) {
      return onProductClick(evt, {
        productCode: code
      });
    },
    onMouseDown: function onMouseDown(evt) {
      return onProductMouseDown(evt, {
        productCode: code
      });
    },
    $_css2: styles.link
  }, /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css3: styles.topInnerCard
  }, /*#__PURE__*/React.createElement(ImageComponent, {
    loading: imageLoading,
    src: getProductImageURL(imageSrc)
  }), (primaryLabelText || deliveryLabelText) && /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css4: styles.imageLabels(!primaryLabelText)
  }, primaryLabelText && /*#__PURE__*/React.createElement(_StyledB, {
    "data-testid": testIds.PRIMARY_LABEL_TEST_ID,
    $_css5: styles.primaryLabel(primaryLabelType)
  }, primaryLabelText), deliveryLabelText && /*#__PURE__*/React.createElement(_StyledB2, {
    "data-testid": testIds.DELIVERY_LABEL_TEST_ID,
    $_css6: styles.deliveryLabel
  }, /*#__PURE__*/React.createElement(IconShipping, {
    color: "var(--brand-purple-base)",
    height: 16,
    width: 16
  }), deliveryLabelText)), /*#__PURE__*/React.createElement(_StyledDiv3, {
    "aria-hidden": true,
    $_css7: styles.soldBy
  }, "Sold by ", /*#__PURE__*/React.createElement("b", null, partnerName))), /*#__PURE__*/React.createElement(_StyledH, {
    $_css8: [styles.copyWrapper, styles.title]
  }, title)), /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css9: [styles.copyWrapper, styles.bottomInnerCard]
  }, /*#__PURE__*/React.createElement(_StyledPriceComponent, {
    amount: price,
    currency: currency,
    testId: testIds.PRICE,
    type: preSalePrice !== undefined ? 'sale' : 'normal',
    $_css10: styles.currentPrice
  }), preSalePrice && /*#__PURE__*/React.createElement(_StyledPriceComponent2, {
    amount: preSalePrice,
    currency: currency,
    testId: testIds.PREVIOUS_PRICE,
    type: "previous",
    $_css11: styles.previousPrice
  }), deliveryEventMessage && /*#__PURE__*/React.createElement(_StyledP, {
    "data-testid": testIds.DELIVERY_EVENT_LABEL_TEST_ID,
    $_css12: styles.labelWrapper
  }, /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css13: styles.deliveryEventMessage
  }, deliveryEventMessage))), /*#__PURE__*/React.createElement(_StyledFavouriteButton, {
    active: favourite,
    onClick: function onClick() {
      return onFavouriteClick === null || onFavouriteClick === void 0 ? void 0 : onFavouriteClick({
        productCode: code
      });
    },
    size: "large",
    $_css14: styles.favouriteButtonWrapper
  }));
};
var _StyledArticle = _styled("article")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledA = _styled2("a")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv2 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledB = _styled5("b")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledB2 = _styled6("b")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledDiv3 = _styled7("div")(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css7;
});
var _StyledH = _styled8("h3")(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css8;
});
var _StyledDiv4 = _styled9("div")(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css9;
});
var _StyledPriceComponent = _styled10(PriceComponent)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css10;
});
var _StyledPriceComponent2 = _styled11(PriceComponent)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css11;
});
var _StyledP = _styled12("p")(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css12;
});
var _StyledSpan = _styled13("span")(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css13;
});
var _StyledFavouriteButton = /*#__PURE__*/_styled14(FavouriteButton).withConfig({
  displayName: "ProductCard___StyledFavouriteButton",
  componentId: "sc-jdbpin-0"
})(["", ""], function (p) {
  return p.$_css14;
});